import * as React from "react";
import { User, Category } from "../api/classes";
import { Avatar, Typography, Select, MenuItem } from "@material-ui/core";
import { connect } from "react-redux";
import { GlobalState } from "../store";
import { RouteComponentProps } from "react-router-dom";
import * as actions from "../store/cases/actions";
import FolderIcon from "@material-ui/icons/Unarchive";
import * as constants from "../api/constants";
interface Props {
  value: string;
  onChange?: () => void;
  onSelect: (id: string) => void;

  style?: React.CSSProperties;
}
const items = [
  {
    id: constants.SOURCE_WHATSAPP,
    label: "Whatsapp"
  },
  {
    id: constants.SOURCE_INSTAGRAM_MESSAGE,
    label: "Instagram DM"
  },
  {
    id: constants.SOURCE_OTHER,
    label: "Other"
  }
];
export default class SourceSelect extends React.Component<Props> {
  handleChange = e => {
    this.props.onSelect(e.target.value);
  };
  render() {
    const { value } = this.props;
    return (
      <div
        style={{
          ...this.props.style,
          position: "relative"
        }}
      >
        <FolderIcon
          style={{
            position: "absolute",
            left: 0,
            top: 5,
            width: 20,
            height: 20
          }}
        />
        <Select
          disableUnderline
          style={{
            alignSelf: "flex-start",
            paddingLeft: 32
          }}
          value={value}
          onChange={this.handleChange}
          inputProps={{
            name: "age",
            id: "age-simple"
          }}
        >
          {items.map(u => {
            return <MenuItem value={u.id}>{u.label}</MenuItem>;
          })}
        </Select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/sourceSelect.tsx